module.exports = __webpack_public_path__ + "static/media/undraw_Air_support_re_nybl.5ebbe987.png";